import { render } from "./funnel-footer.vue?vue&type=template&id=0789ddf2&scoped=true"
import script from "./funnel-footer.vue?vue&type=script&lang=js"
export * from "./funnel-footer.vue?vue&type=script&lang=js"

import "./funnel-footer.vue?vue&type=style&index=0&id=0789ddf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0789ddf2"]])

export default __exports__